module.exports = __webpack_public_path__ + "img/日历签到3.7cf2c578.png";